module.exports = __webpack_public_path__ + "static/media/logo3.57bfd1b7.png";